// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__fWNEF","image":"style_image__Krd6k","image_desk":"style_image_desk__rqiKK","image_mobile":"style_image_mobile__kEUVK"};